var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5872V7.58716C7 6.26108 7.52678 4.98931 8.46447 4.05162C9.40215 3.11394 10.6739 2.58716 12 2.58716C13.3261 2.58716 14.5979 3.11394 15.5355 4.05162C16.4732 4.98931 17 6.26108 17 7.58716V11.5872M5 11.5872H19C20.1046 11.5872 21 12.4826 21 13.5872V20.5872C21 21.6917 20.1046 22.5872 19 22.5872H5C3.89543 22.5872 3 21.6917 3 20.5872V13.5872C3 12.4826 3.89543 11.5872 5 11.5872Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/LockIcon.0852cf5d8c4e09437c17b2cc1c7f1b65.svg";
export { ForwardRef as ReactComponent };